import { EventKey } from "PFTypes/event_key";

export type CellCoord = {
  rowIndex: number;
  colIndex: number;
};

export type CellRange = {
  anchor: CellCoord;
  active: CellCoord;
};

/**
 * Which outer edges of a range this cell sits on.
 * null means the cell is not in the range at all.
 */
export type RangeEdges = {
  top: boolean;
  bottom: boolean;
  left: boolean;
  right: boolean;
};

export type NormalizedRange = {
  minRow: number;
  maxRow: number;
  minCol: number;
  maxCol: number;
};

export enum DragAxis {
  Horizontal = "horizontal",
  Vertical = "vertical",
  Both = "both"
}

export type FillEvent = {
  sourceCell: CellCoord & { value: unknown };
  targetRange: NormalizedRange;
};

export type CopyEvent = {
  range: NormalizedRange;
  tsv: string;
};

/**
 * Fired by InteractiveTable when the user presses Cmd/Ctrl+V.
 *
 * `anchor` — the top-left cell where the paste begins (the current selection anchor).
 * `values` — a 2D array of strings parsed from the clipboard TSV.
 *             values[rowOffset][colOffset] where (0,0) is the anchor cell.
 * `tsv`    — the raw clipboard text, provided for cases where the consumer
 *             wants to do its own parsing.
 */
export type PasteEvent = {
  anchor: CellCoord;
  values: string[][];
  tsv: string;
};

export type ClearEvent = {
  targetRange: NormalizedRange;
};

export type TableBounds = {
  rowCount: number;
  colCount: number;
};

export type ArrowDirection = EventKey.ArrowUp | EventKey.ArrowDown | EventKey.ArrowLeft | EventKey.ArrowRight;

/**
 * How edit mode was triggered — determines what the focused input should do:
 * - Overwrite: user started typing, replace the current value immediately.
 * - CursorAtEnd: Enter or double-click, position cursor at end of existing value.
 */
export enum EditTrigger {
  Overwrite = "overwrite",
  CursorAtEnd = "cursorAtEnd"
}
